import React from 'react';
import Iframe from 'react-iframe';
import { ROOT_URL, BANKDATA_URL } from '../../Actions/types'


class FastlinkEdit extends React.Component {

  state = { url: `${BANKDATA_URL}/fastlinktoken/${localStorage.getItem("bookid")}/#${localStorage.getItem('token')}` }

  componentDidMount() {
    window.addEventListener('message', this.handleFrameTasks);
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
  }
  handleFrameTasks = e => {
    if(e.data === 'closeyodlee') this.props.closeYodlee();
  };

  handleFrameTasks = e => {
    if(e.data === 'closeyodlee') this.props.closeYodlee();
    if(e.data === 'goToYodlee') {
      const { feed } = this.props;
      const provideraccountid = feed.YodleeItemID;
      this.setState({ url: `${ROOT_URL}/bankfeed/fastlinklogin?bookid=${localStorage.getItem("bookid")}&cognitotoken=${localStorage.getItem('cognitotoken')}&authorizationtoken=${localStorage.getItem('token')}&flow=edit&provideraccountid=${provideraccountid}` });
    }
  };

  render() {

    return (
      <div>
        <Iframe
          url={this.state.url}
          width="750px"
          height="620px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </div>
    );
  }
}

export default FastlinkEdit;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/FastlinkEdit.js